import { isUserData, Organization, Owner } from "common/Database";
import { connect } from "react-redux";
import { RootState } from "store/types";
import { logError } from "common/debug-print";
import { encodeCopyTemplateMessage } from "designer/lib/copy-template-message";
import { PurchaseAppScreen, Props } from "./purchase-generic";

type TemplateProps = Props &
    Readonly<{
        organizations: readonly Organization[];
        organizationsLoaded: boolean;
    }>;

class PurchaseTemplateScreen extends PurchaseAppScreen<TemplateProps> {
    protected async performStripeRedirectIfNecessary() {
        const { userData, organizations, organizationsLoaded } = this.props;
        if (!isUserData(userData)) return;

        let targetOwner: Owner = userData;
        const onBehalfOf = this.onBehalfOf();

        if (onBehalfOf !== undefined && onBehalfOf !== userData.id) {
            if (!organizationsLoaded) return;
            const targetOrganization = organizations.find(o => o.id === onBehalfOf);
            if (targetOrganization === undefined) {
                this.closeWindow();
                return;
            }
            targetOwner = targetOrganization;
        }

        const targetAppID = this.getTargetAppID();
        if (targetOwner.templateLicenses.indexOf(targetAppID) >= 0) {
            this.setHandled();
            if (window.opener !== null) {
                window.opener.postMessage(encodeCopyTemplateMessage(targetAppID, onBehalfOf), window.location.origin);
            }
            this.closeWindow();
            return;
        }

        if (this.successParameterIsSet()) {
            // When we succeed, we are told by Stripe that the transaction
            // was successful. Instead of trying to go through Stripe Checkout,
            // we just wait around until the license shows up.
            return;
        }

        this.setHandled();
        try {
            await this.performStripeRedirect({ endpoint: "acquireStripeSessionForTemplatePurchase" });
        } catch (e: unknown) {
            logError(`Could not redirect to Stripe for template purchase:`, e);
        }
    }
}

const mapState = (state: RootState) => ({
    userData: state.userData,
    organizations: state.organizations,
    organizationsLoaded: state.organizationsLoaded,
});

export default connect(mapState)(PurchaseTemplateScreen);
